import type { ID } from '@octopus-do/octopus-project-core'
import { createAction } from '@reduxjs/toolkit'

export interface ProjectStatus {
  id: ID
  title: string
  color: string
}

export interface StatusResult {
  statuses: ProjectStatus[]
  status: ProjectStatus | null
}

export type StatusOperation =
  | { type: 'load' }
  | { type: 'set'; statusId: ID | null }
  | { type: 'create'; title: string; color: string }
  | {
      type: 'update'
      id: ID
      changes: Partial<Pick<ProjectStatus, 'title' | 'color'>>
    }
  | { type: 'delete'; id: ID }
  | { type: 'move'; id: ID; direction: 'up' | 'down' }

export interface StatusRequest {
  projectId: ID
  operation: StatusOperation
}

export interface StatusResponse extends StatusResult {
  workspaceId: ID
  projectId: ID
}

export const StatusActions = {
  request: createAction<StatusRequest>('DASHBOARD_STATUS_REQUEST'),
  received: createAction<StatusResponse>('DASHBOARD_STATUS_RECEIVED'),
}
